"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
const Button_1 = __importDefault(require("@mui/material/Button"));
function default_1({ changePublicStatusFn, isStoryCard, }) {
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ fullWidth: true, onClick: changePublicStatusFn, sx: {
            alignSelf: 'flex-end',
            p: '4px',
            border: '1px solid rgba(0, 0, 0, 0.1)',
            mt: isStoryCard ? 'auto' : '2px',
            lineHeight: '21px',
            fontSize: '14px',
            bgcolor: 'white !important',
            color: 'black',
        } }, { children: t('공개 안 함') })));
}
exports.default = default_1;
